export const PANORAMA_OFFERING_TEXTS = {
  OFFERINGS: {
    LEARNING_RESOURCE_SECTION: {
      SECTION_TITLE: 'Authoritative Resources',
    },
    SUPPORTED_HOURS_SECTION: {
      RESPONSE_TIME: 'Response time',
    }
  }
}

export const SEARCH_RESULT_TEXTS = {
  FILTERS_HEADING: 'Filters',
};
